export const NO_OPTION_SELECTION_TEXT = 'Please Select';
